require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-132-teamgantt-api.json") })
        }
      }, "path---article-132-teamgantt-api");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-132-teamgantt-api!./.cache/json/article-132-teamgantt-api.json
// module id = 486
// module chunks = 231608221292675